<template>
  <v-app>
    <!--<v-navigation-drawer v-model="drawer" app>
      <ul>
        <li v-for="r in this.$router.options.routes" :key="r.name">
          <router-link :to="r.path">
            <v-icon>{{ r.icon }}</v-icon>
            {{ r.name }}
          </router-link>
        </li>
      </ul>
    </v-navigation-drawer-->

    <v-app-bar app dark color="primary">
      <!-- -->
      <!--v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon -->
      <v-toolbar-title>
        <router-link to="/">
          <v-btn text icon color="secondary">
            <v-icon>home</v-icon>
          </v-btn>
          &nbsp;
          <span style="color: #BBBBBB">Cyrille</span>
          <span class="font-weight-black" style="color: white">Berliat</span>
        </router-link>
      </v-toolbar-title>
    </v-app-bar>

    <!-- Sizes your content based upon application components -->
    <v-content>

      <!-- Provides the application the proper gutter -->
      <v-container fluid grid-list-md text-center>
        <slot></slot>
      </v-container>
    </v-content>

    <v-footer app dark color="primary">
      <ul id="contact">
        <li v-for="c in contacts" :key="c.icon">
          <a :href="c.href" target="_blank">
            <v-btn 
              :x-small="$vuetify.breakpoint.smAndDown ? true : false"
              text icon color="secondary">
              <v-icon dark>{{ c.icon }}</v-icon>
            </v-btn>
          </a>
        </li>
      </ul>
    </v-footer>
  </v-app>
</template>

<script>
  export default {
    components: {
    },
    data: () => ({
      drawer: null,
      contacts: [
        {icon: 'fab fa-linkedin', href:"http://linkedin.com/in/cyrilleberliat"},
        {icon: 'fab fa-facebook', href:"http://facebook.com/cyrille.berliat"},
        {icon: 'fab fa-instagram', href:"http://instagram.com/licryle"},
        //{icon: 'fab fa-twitter', href:"http://twitter.com/licryle"},
        {icon: 'email', href:"mailto:cyrille.berliat+site@gmail.com"}
      ]
    })
  }
</script>

<style scoped>
  .container {
    max-width: 60em;
    margin: 0 auto;
    padding: 15px 30px;
    background: #FFFFFF;
  }
  UL#contact LI {
    display: inline-block;
  }
</style>